const cache = {
    cache: {},
    
    set: (key, value) => {
        cache.cache[key] = value;
    },

    get: (key) => {
        return cache.cache[key] || null;
    }
}
export default cache;